<div class="flex flex-wrap gap-md sm:flex-nowrap">
  <ng-content select="cft-holy-grail-grid-col-left"></ng-content>
  <ng-content select="cft-holy-grail-grid-content"></ng-content>
  <ng-content select="cft-holy-grail-grid-col-right"></ng-content>
</div>
